import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import theme from './theme'
import GlobalStyles from './Global.Styled'
import { ToastProvider } from './components/hooks/useToast'
import Landing from './components/Landing/Landing'

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <ToastProvider>
          <Router>
            <Routes>
              {/* public landing */}
              <Route index element={<Landing />} />

              {/* fallback routing */}
              <Route path={'*'} element={<Navigate replace to="/" />} />
            </Routes>
          </Router>
        </ToastProvider>
      </ThemeProvider>
    </div>
  )
}

export default App
